import React from "react";
import "../styles/css/contact.css";
import Form from "../components/contact/Form";
const Contact = () => {
  return (
    <div className="contact" id="contact">
      <Form />
    </div>
  );
};

export default Contact;
